import { render, staticRenderFns } from "./viewSalesReturn.vue?vue&type=template&id=79f573e9&scoped=true&"
import script from "./viewSalesReturn.vue?vue&type=script&lang=js&"
export * from "./viewSalesReturn.vue?vue&type=script&lang=js&"
import style0 from "./viewSalesReturn.vue?vue&type=style&index=0&id=79f573e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f573e9",
  null
  
)

export default component.exports